<template>
  <modal :show.sync="modals.modal1" footerClasses="text-right" :largeModal="true">
    <h6 slot="header" class="modal-title text-success font-weight-bold" id="modal-title-default">
      {{ title }}
    </h6>
    <div class="d-block">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form ref="form" @submit.stop.prevent="handleSubmit(submit)">
          <p class="description">
            * Registrasi User, silahkan isi field di bawah ini.
          </p>
          <div class="alert alert-danger" v-if="error_msg.length > 0">
            <strong>Warning!</strong> Perbaiki hasil input Anda :
            <ul>
              <li v-for="text in error_msg" :key="text">{{ text }}</li>
            </ul>
          </div>
          <div class="mb-5">
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-4 col-sm-12">
                    <div class="form-group">
                      <select class="form-control" name="status_user" v-model="form.status_user" :class="'is-valid'"
                        :disabled="edit">
                        <option value="1">1 - PPAT</option>
                        <option selected="selected" value="2">
                          2 - Wajib Pajak
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 col-sm-12">
                    <ValidationProvider name="Nama" rules="required|max:255" v-slot="{ errors }">
                      <base-input label="Nama" v-model="form.name" :required="true" :error="errors[0]"
                        :valid="!errors[0]"></base-input>
                    </ValidationProvider>
                  </div>
                  <div class="col-md-6 col-sm-12">
                    <ValidationProvider name="Email" rules="required|email" v-slot="{ errors }">
                      <base-input label="Email" v-model="form.email" :required="true" :error="errors[0]"
                        :disabled="edit" :valid="!errors[0]"></base-input>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6 col-sm-12">
                    <ValidationProvider name="NIK" rules="required|max:16|numeric" v-slot="{ errors }">
                      <base-input label="NIK" v-model="form.nik" :required="true" :error="errors[0]"
                        :valid="!errors[0]"></base-input>
                    </ValidationProvider>
                  </div>
                  <div class="col-md-6 col-sm-12">
                    <ValidationProvider name="No Tlp. / WA" rules="required|max:12|numeric" v-slot="{ errors }">
                      <base-input label="No Tlp. / WA" v-model="form.phone_number" :required="true" :error="errors[0]"
                        :valid="!errors[0]"></base-input>
                    </ValidationProvider>
                  </div>
                </div>
                <fieldset v-if="!edit">
                  <legend>Password User</legend>
                  <div class="row">
                    <div class="col-md-6 col-sm-12">
                      <ValidationProvider name="Password" rules="required|max:20|min:6" v-slot="{ errors }">
                        <base-input type="password" placeholder="Password Lama" addon-left-icon="ni ni-lock-circle-open"
                          v-model="form.password" :required="true" :error="errors[0]" :valid="!errors[0]"></base-input>
                      </ValidationProvider>
                    </div>

                    <div class="col-md-6 col-sm-12">
                      <ValidationProvider name="Konfirmasi Password" rules="required|max:20|min:6" v-slot="{ errors }">
                        <base-input type="password" placeholder="Password Konfirmasi"
                          addon-left-icon="ni ni-lock-circle-open" v-model="form.password_confirmation" :required="true"
                          :error="errors[0]" :valid="!errors[0]"></base-input>
                      </ValidationProvider>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
          </div>
          <div class="row float-right">
            <div class="col-md-12 col-sm-12">
              <template v-if="isBusy">
                <pulse-loader :loading="isBusy" :color="'#d7f6e8'"></pulse-loader>
                <strong>Loading...</strong>
              </template>
              <base-button v-else type="success" nativeType="submit" icon="ni ni-send">{{ edit ? "Update" : "Daftar" }}
              </base-button>
              <base-button type="warning" @click="modals.modal1 = false">Tutup</base-button>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </modal>
</template>
<script>
import Modal from "@/components/Modal.vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import Swal from "sweetalert2";
import qs from "qs";
import axios from "axios";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
export default {
  components: {
    Modal,
    PulseLoader,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  props: {
    title: {
      type: String,
      description: "Judul Modal",
    },
    code: {
      type: String,
      description: "Code Pajak",
    },
    url: {
      type: String,
      description: "Url Pajak",
    },
  },
  data() {
    return {
      modals: {
        modal1: false,
      },
      form: {
        id: null,
        nik: null,
        name: null,
        email: null,
        phone_number: null,
        status_user: 2,
        password: null,
        password_confirmation: null,
      },
      isBusy: false,
      error_msg: [],
      edit: false,
    };
  },
  methods: {
    showModal() {
      this.edit = false;
      this.modals.modal1 = true;
      this.form.id = null;
      this.form.nik = null;
      this.form.name = null;
      this.form.email = null;
      this.form.phone_number = null;
      this.form.password = null;
      this.form.password_confirmation = null;
      this.form.status_user = 1;
    },
    updateMode(data) {
      this.form.id = data.id;
      this.form.nik = data.nik;
      this.form.name = data.name;
      this.form.email = data.email;
      this.form.phone_number = data.phone_number;
      this.form.status_user = data.status_user;
      this.edit = true;
    },
    hideModal() {
      this.modals.modal1 = false;
    },
    async submit() {
      const me = this;
      try {
        me.error_msg = [];
        this.isBusy = true;
        let { data, status } = this.edit ? await axios.post(
          "/api/v1/user/update",
          qs.stringify({ user_online: me.form })
        ) :
          await axios.post(
            "/api/v1/register",
            qs.stringify({ user_online: me.form })
          );

        if (status >= 200 && status <= 202) {
          Swal.fire({
            title: "",
            text: data.msg,
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Tutup!",
          }).then(() => {
            this.$store.dispatch("auth/set_user", data.user);
            me.hideModal();
          });
        }
        this.isBusy = false;
      } catch (error) {
        console.log(error);
      } finally {
        this.isBusy = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.modal-dialog {
  max-width: 80% !important;
  margin: 1.75rem auto;
}

.has-success:after,
.has-danger:after {
  width: 19px;
  height: 19px;
  line-height: 19px;
  text-align: center;
  font-family: "NucleoIcons";
  display: inline-block;
  position: absolute;
  right: 15px;
  top: 29px;
  -webkit-transform: translateY(50%);
  transform: translateY(50%);
  border-radius: 50%;
  font-size: 9px;
  opacity: 1;
}

.input-group.has-success:after,
.input-group.has-danger:after {
  width: 19px;
  height: 19px;
  line-height: 19px;
  text-align: center;
  font-family: "NucleoIcons";
  display: inline-block;
  position: absolute;
  right: 15px;
  top: 0px;
  -webkit-transform: translateY(50%);
  transform: translateY(50%);
  border-radius: 50%;
  font-size: 9px;
  opacity: 1;
}

fieldset {
  border: 2px solid green;
  -moz-border-radius: 8px;
  -webkit-border-radius: 8px;
  border-radius: 8px;
  padding: 10px;
}
</style>